import { useEffect, useRef } from 'react';
import { useDialogManager } from './DialogManagerProvider.tsx';
export function useDialogTracking(open, onClose) {
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;
    const manager = useDialogManager();
    useEffect(()=>{
        if (!open) return;
        return manager.register({
            close: ()=>onCloseRef.current()
        });
    }, [
        open,
        manager
    ]);
}
